import {
  ACTIONS_FOR_SUPPORT_NAMES,
  LEGAL_FRAMEWORK_AND_RISKS_NAMES,
  LIST_OF_RISKS_NAMES,
} from '../Sections/LegalFrameworkAndRisks/utils/form';

const ACTIONS_INSTRUCTIONS = {
  [ACTIONS_FOR_SUPPORT_NAMES.ACTION]: {
    name: 'Stage',
    instruction:
      "List all the mandatory legal procedures relevant to the company's operations. Identify critical legal processes, filings, or steps integral to meeting regulatory requirements.",
    exampleOne: 'Obtain USDA Agricultural Equipment Safety Certification',
    exampleTwo: 'Register trademark',
  },
  [ACTIONS_FOR_SUPPORT_NAMES.START_DATE]: {
    name: 'Deadlines',
    instruction: 'Specify the current status for each procedure and the expected timeframe for finalization.',
    exampleOne: 'May 2024',
    exampleTwo: '',
  },
  [ACTIONS_FOR_SUPPORT_NAMES.EXPECTED_DEADLINE]: {
    name: 'Deadlines',
    instruction: 'Specify the current status for each procedure and the expected timeframe for finalization.',
    exampleOne: 'done',
    exampleTwo: 'August 2024',
  },
};

const RISKS_INSTRUCTIONS = {
  [LIST_OF_RISKS_NAMES.NAME]: {
    name: 'Name of risk',
    instruction:
      'Identify and clearly state the name of the risk. Ensure it is specific and relevant to the context, using terminology that accurately describes the nature of the risk.',
    exampleOne: 'Fluctuating commodity prices ',
    exampleTwo: 'Fluctuating exchange rates',
  },
  [LIST_OF_RISKS_NAMES.GROUP]: {
    name: 'Risk group',
    instruction:
      "Indicate the risk group succinctly, highlighting whether it's economic risks, organizational risks, market risks, production and technical risks, legal risks or other risks.",
    exampleOne: 'Economic risks',
    exampleTwo: 'Economic risks',
  },
  [LIST_OF_RISKS_NAMES.NEGATIVE_IMPACT]: {
    name: 'Negative impact',
    instruction:
      'Illustrate the adverse effects of risks, emphasizing potential losses, disruptions, and damage to reputation or operations.',
    exampleOne:
      'Uncertain demand for agricultural machinery can impact Agrotech`s revenue and profitability through fluctuations in commodity prices. Price increases may deter farmers from investing, while decreases may affect the Company`s margins and sales volume.',
    exampleTwo:
      'Fluctuations in currency exchange rates affect the import costs of raw materials and export revenues of the Company. Unfavorable rates increase production expenses, reducing profitability, while favorable rates may enhance competitiveness but can also affect pricing strategies.',
  },
  [LIST_OF_RISKS_NAMES.PREVENTION_MEASURES]: {
    name: 'Prevention measures',
    instruction:
      'Initiate the discussion by providing an overview of the specific measures your project has implemented to mitigate identified risks. Provide detailed insights into the proactive steps to address each identified risk, such as implementing risk diversification strategies, leveraging insurance policies, establishing contingency funds, or forming strategic partnerships.',
    exampleOne:
      'The Company can diversify its product range, invest in research for cost-efficient manufacturing, establish long-term contracts with suppliers, and implement flexible pricing strategies.',
    exampleTwo:
      'The Company can hedge using financial instruments, diversify its customer base across regions, localize production to reduce reliance on imports, and negotiate long-term contracts denominated in stable currencies.',
  },
};

export const LEGAL_FRAMEWORKS_AND_RISKS_SECTION_INSTRUCTIONS = {
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.GENERAL_LAWS]: {
    name: 'General Laws and Regulations',
    instruction:
      'Identify the jurisdiction where your company operates and list the laws and regulations that govern it. The list may include corporate law, labour laws, and tax laws. Ensure compliance by referencing relevant acts and statutes, facilitating lawful operation within the specified jurisdiction.',
    exampleOne:
      'The Company operates in the United States and is subject to various laws and regulations, including the Internal Revenue Code for tax compliance, the Fair Labor Standards Act for labour regulations, and the Securities Act of 1933 for corporate governance.',
    exampleTwo:
      'The Company operates within the jurisdiction of California, USA. The California Corporations Code, California Labor Code, and California Revenue and Taxation Code regulate the Company. Compliance ensures lawful operation within the specified jurisdiction.',
  },
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.INDUSTRY_REQUIREMENTS]: {
    name: 'Specific Industry Requirements',
    instruction:
      'Detail industry-specific laws your company must adhere to. Specify licensing, certification, or permits needed for compliance. Ensure clarity and accuracy in outlining these requirements.',
    exampleOne:
      'The Company comply with industry-specific laws such as the Agricultural Improvement Act of 2018 (Farm Bill) for agricultural regulations. Additionally, the Company has certifications in ISO 9001, Emission Standards Compliance Certificate, and USDA Agricultural Equipment Safety Certification.',
    exampleTwo:
      'The Company must adhere to industry-specific laws such as the Translation and Interpreting Services Act in the language services industry. Compliance requires obtaining licenses from the American Translators Association and the International Association of Professional Translators and Interpreters.',
  },
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.LEGAL_REQUIREMENTS]: {
    name: 'Compliance with Legal Requirements',
    instruction:
      'Review the company`s compliance status with legal requirements for business operations. Identify gaps or deficiencies and propose a corrective plan for complete adherence to regulatory standards.',
    exampleOne:
      'The Company is currently compliant with legal requirements. To address gaps, the Company is pursuing the USDA Agricultural Equipment Safety Certification, with necessary documents already submitted for approval by the US Certification Department.',
    exampleTwo:
      'The Company complies with all legal requirements for conducting business, including regulations for language services, licensing, certifications, and permits in relevant jurisdictions.',
  },
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.LIST_OF_ACTIONS]: ACTIONS_INSTRUCTIONS,
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.LIST_OF_RISKS]: RISKS_INSTRUCTIONS,
};
